import React from "react";
import {Loading3QuartersOutlined} from "@ant-design/icons";
import {Spin} from "antd";
import styles from "./index.module.scss";

const antIcon = (
  <Loading3QuartersOutlined
    style={{
      fontSize: 24,
      color: "#6e8cff",
    }}
    spin
  />
);

function Spinner() {
  return (
    <div className={styles.container}>
      <Spin indicator={antIcon} />
    </div>
  );
}

export default Spinner;
